import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-sidom-light dark:bg-sidom-blue">
      <h1 className="text-4xl md:text-6xl font-bold text-sidom-orange mb-4">
        404 - Ruta no encontrada
      </h1>
      <p className="text-lg md:text-xl text-sidom-light mb-8">
        Lo sentimos, la página que buscas no existe.
      </p>
      <Link
        to="/"
        className="px-6 py-3 bg-sidom-orange text-sidom-light rounded-md hover:bg-sidom-orange/80"
      >
        Volver al inicio
      </Link>
    </div>
  );
}
